import React from "react";
import { Col, Modal, Row } from "react-bootstrap";
import Image from "../assets/img/close-icon.svg";
import Search from "../assets/img/search-icon.svg";
import Grade from "../assets/img/grade-1.svg";
import Star from "../assets/img/student-profile.svg";
import Tick from "../assets/img/tick-fade.svg";
import ColorTick from "../assets/img/status-check.svg";
import Select from "react-select";
import { useEffect } from "react";
import { GetFunction, handleimageUrl } from "../utils/ApiFunctions";
import { useState } from "react";
import { useLocalization } from "./Localization/Localization";
import { GetValueLableWithId } from "../utils/Helper";
function SelectStarModal(props) {
  const schoolId = localStorage.getItem("school");
  const [classList, setClassList] = useState([]);
  const [options, setOptions] = useState([]);
  const [sectionList, setSectionList] = useState([]);

  const [starList, setStartList] = useState([]);
  const [gradeId, setGradeId] = useState("");

  const [sectionId, setSctionId] = useState("");
  const [selectStarStudent, SetSelectedStudentData] = useState([]);
  const [selectId, setSelectedIds] = useState([]);
  const [keywords, setKeyWords] = useState("");
  const GetStarList = async () => {
    const res = await GetFunction(
      `registerStar/star_list?school=${schoolId}&classId=${gradeId}&section=${sectionId}&keyword=${keywords}`
    );
    if (res?.status == 200) {
      setStartList(res?.data?.data);
    }
  };

  useEffect(() => {
    if (props.show) {
      GetStarList();
      setSelectedIds(
        props.prevoiusdata?.map((val) => {
          return val?._id;
        })
      );
      SetSelectedStudentData(props.prevoiusdata);
    }
  }, [props.show, keywords, sectionId, gradeId]);

  const GetClassList = async () => {
    const res = await GetFunction(
      `/class/getAll?schoolid=${schoolId}&pages=all`
    );
    if (res.status == 200) {
      setClassList(res?.data?.data?.data);
      setOptions(GetValueLableWithId(res?.data?.data?.data, ["_id", "name"]));
    }
  };

  useEffect(() => {
    if (schoolId && props.show) {
      GetClassList();
    }
  }, [schoolId, props.show]);

  const GetSectionList = async () => {
    const res = await GetFunction(
      `/class/section/getall?multiClassId=${gradeId}&pages=all`
    );
    if (res.status == 200) {
      setSectionList(res?.data?.data?.data);
      setSectionList(
        GetValueLableWithId(res?.data?.data?.data, ["_id", "name"])
      );
    }
  };
  useEffect(() => {
    if (gradeId) {
      GetSectionList();
    }
  }, [gradeId]);

  const saveData = (val) => {
    if (selectId.includes(val?._id)) {
      SetSelectedStudentData(
        selectStarStudent.filter(
          (selectedPerson) => selectedPerson?._id !== val?._id
        )
      );
      setSelectedIds(selectId?.filter((vals) => vals !== val?._id));
    } else {
      SetSelectedStudentData((pre) => [...pre, val]);
      setSelectedIds((pre) => [...pre, val._id]);
    }
  };

  const { t } = useLocalization();

  return (
    <Modal
      {...props}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className=""
    >
      <Modal.Body>
        <div className="edit-profile p-4">
          <h2>{t("select_stars")}</h2>

          <button
            closeButton
            className="btn-btn-close"
            onClick={() => props?.onHide()}
          >
            <img src={Image} alt="" />
          </button>
          <div className="filter-section-data cmn-frm">
            <Row>
              <Col md={6} className="">
                <div className="form-group">
                  {/* <select onChange={(e) => setGradeId(e.target.value)}>
                     <option selected value="" disabled>
                      <h2>{t("select_grade")}</h2>
                    </option>
                    {classList &&
                      classList?.map((val, i) => (
                        <option value={val?._id}>{val.name}</option>
                      ))}
                  </select> */}
                  {/* <img className="ipt-icn img-fluid" src={Grade} /> */}

                  <Select
                    placeholder={t("select_grade")}
                    options={options}
                    onChange={(option) => {
                      setGradeId(option.value);
                    }}
                    value={options.find((option) => option.value === gradeId)}
                  />
                </div>
              </Col>
              <Col md={6} className="ps-0">
                {/* <select onChange={(e) => setSctionId(e.target.value)}>
                  <option selected value="" disabled>
                    Select Section
                  </option>
                  {sectionList &&
                    sectionList?.map((val, i) => (
                      <option value={val?._id}>{val?.name}</option>
                    ))}
                </select> */}

                <Select
                  placeholder={t("select_grade")}
                  options={sectionList}
                  onChange={(option) => {
                    setSctionId(option.value);
                  }}
                  value={sectionList.find(
                    (option) => option.value === sectionId
                  )}
                />
              </Col>
              <Col md={12} className="border-top-1">
                <div className="form-group">
                  <input
                    type="text"
                    placeholder={t("search")}
                    value={keywords}
                    onChange={(e) => setKeyWords(e.target.value)}
                  />
                  {/* <img className="ipt-icn img-fluid" src={Search} /> */}
                </div>
              </Col>
            </Row>
          </div>

          {starList &&
            starList?.map((val, i) =>
              selectId?.includes(val?._id) ? (
                <div
                  key={i}
                  className="star-list-selct active"
                  onClick={(e) => {
                    e.preventDefault();
                    saveData(val);
                  }}
                >
                  <div className="star-profile-1">
                    <img
                      src={
                        val?.user?.profilePic != ""
                          ? handleimageUrl(val?.user?.profilePic)
                          : Star
                      }
                    />
                  </div>
                  <div className="star-profile-1 h-auto w-auto">
                    <h3>
                      {" "}
                      {val?.user.name} <span>#{val?.studentId}</span>
                    </h3>
                  </div>
                  <img src={ColorTick} />
                </div>
              ) : (
                <div
                  className="star-list-selct "
                  onClick={(e) => {
                    e.preventDefault();
                    saveData(val);
                  }}
                >
                  <div className="star-profile-1">
                    <img
                      src={
                        val?.user?.profilePic != ""
                          ? handleimageUrl(val?.user?.profilePic)
                          : Star
                      }
                    />
                  </div>
                  <div className="star-profile-1 h-auto w-auto">
                    <h3>
                      {" "}
                      {val?.user?.name} <span>#{val?.studentId}</span>
                    </h3>
                  </div>
                  <img src={Tick} />
                </div>
              )
            )}

          <div className="text-center mt-4">
            <button
              className="btn-btn-primary "
              onClick={() => {
                props?.Selectdata(selectStarStudent);

                props?.onHide();
              }}
            >
              {t("continue")}
            </button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default SelectStarModal;
